<template>
  <!--按角色发奖-->
  <div class="m-b-20" v-if='form.send_award_type == 1'> 
    <div class="m-b-20 s_flex_bian_c">
      <a-button type="primary" @click="create">
        <PlusOutlined />
        指定发奖
      </a-button>
      <div>
        <span class="s_c333">奖项说明：</span>{{ code_num }}
        <a-tooltip placement="right">
          <template #title>
            1.默认奖项内容不能删除；防止出现只设置了某一门店类型人员奖项时，其他门店类型人员扫码无奖可领取的情况
            2.一个二维码只能开一次奖，开奖时会根据扫码人的门店身份开出相应的奖项内容
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </div>
    </div>
    <a-table :pagination="false" :loading="listLoading" bordered rowKey="award_id" :columns="columns" :data-source="list"
      :scroll="{ x: 'max-content' }">
      <template v-slot:is_ploy="{ record }">
        {{ record.is_ploy ? "是" : "否" }}
      </template>
      <template v-slot:bonus_id="{ record }">
        <span>{{ record }}</span>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="primary" size="small" href="javascript:;" @click="edit(record)">修改</a-button>
        <a-popconfirm title="确定要删除该奖项么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight">
          <a-button v-if="record.is_default!=1" class="m-l-10" type="danger" size="small" href="javascript:;">删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
  <!-- 按概率发奖 -->
  <div class="m-b-20" v-if='form.send_award_type == 2'> 
    <div class="m-b-20">
      <a-button type="primary" @click="addOdd">
        <PlusOutlined />
        添加奖项
      </a-button>
      <p class="m-t-15">
        <span class="p-r-20">二维码数量：{{oddCount.code_num||0}}</span>
        <span>综合中奖率：{{oddCount.percent||0}}%</span>
      </p>
    </div>
    <a-table :pagination="false" :loading="listLoading" bordered rowKey="award_id" :columns="columns1" :data-source="oddList"
      :scroll="{ x: 'max-content' }">
      <template v-slot:award_content_arr="{ record }">
        <p v-for="item in record.award_content_arr" :key="item">{{item}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="primary" size="small" href="javascript:;" @click="showProbability=true;oddType='edit';odd_award_id=record.award_id">修改</a-button>
        <a-popconfirm title="确定要删除该奖项么？" @confirm="oddsDel(record)" ok-text="删除" cancel-text="取消" placement="topRight">
          <a-button class="m-l-10" type="danger" size="small" >删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
  <a-form ref="ruleForm" :model="form" :rules="rules" :labelCol="{ span: 3 }" :wrapper-col="{ span: 20 }">
    <a-form-item label="店老板同步发奖" >
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_boss"></a-switch>
      <a-tooltip placement="right">
        <template #title>
          1.店老板同步发奖：开启后，如果店员或店长开奖成功后，会同时给店老板也发放一份奖项，奖项内容可以与开奖人员的奖项一致，也可以不一致
          2.开启后，如果是店老板自己开奖成功的，不会执行该项配置
        </template>
        <InfoCircleOutlined class="m-l-10" />
      </a-tooltip>
      <div v-if="form.is_boss">
        <a-form-item label="奖品设置" require name="many_awards_type" style="margin-bottom: 0">
          <a-radio-group name="many_awards_type" v-model:value="form.boss_type">
            <a-radio :value="1">奖项与店员/店长一致</a-radio>
            <a-radio :value="2">单独设置</a-radio>
          </a-radio-group>
          <div v-if="form.boss_type == 2">
            <a-row :gutter="16">
              <a-col :span="3">
                <a-checkbox v-model:checked="form.boss_is_bonus" @change="handelchange">红包
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-input v-model:value="bonus.boss_bonus_name" readonly aria-placeholder="请选择" />
              </a-col>
              <a-col :span="6">
                <a-button type="primary" @click="showRed2 = true">
                  选择
                </a-button>
              </a-col>
            </a-row>
            <p>为避免红包零钱发放失败,请确保红包零钱余额充足</p>
            <a-row :gutter="16">
              <a-col :span="3">
                <a-checkbox v-model:checked="form.boss_is_point">积分
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-input v-model:value="form.boss_point_num" placeholder="请选择" />
              </a-col>
              <a-col :span="12"> </a-col>
            </a-row>
          </div>
        </a-form-item>
      </div>
    </a-form-item>
    <a-form-item label="奖励发放审核">
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.award_is_permit"></a-switch>
    </a-form-item>
    <a-form-item label="奖励发放时机">
      <a-radio-group v-model:value="form.send_award_mode">
        <a-radio :value="0">中奖（审核通过）即发放</a-radio>
        <a-radio :value="1">每月固定日期发放</a-radio>
      </a-radio-group>
      <div class="s_flex_ali" v-if="form.send_award_mode==1">
        <p>每月</p>
        <a-input-number class="m-l-10 m-r-10" v-model:value="form.send_award_mode_day" :min='1' :max="25" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
        <p>号发放</p>
      </div>
    </a-form-item>
    <a-form-item label="提交资料">
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.scan_award_is_collection"></a-switch>
      <div v-if="form.scan_award_is_collection==1">
        <a-checkbox v-model:checked="form.scan_award_collection_is_sale_bill">销售小票</a-checkbox>
        <a-checkbox v-model:checked="form.scan_award_collection_is_gps_position">GPS定位</a-checkbox>
        <a-checkbox v-model:checked="form.scan_award_collection_is_product_img">产品图片</a-checkbox>
      </div>
    </a-form-item>
    <a-form-item label="开奖次数设置">
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.scan_award_is_confine"></a-switch>
      <div v-if="form.scan_award_is_confine==1">
        <a-radio-group name="many_awards_type" v-model:value="form.scan_award_confine_mode">
          <a-radio :value="1">开奖次数</a-radio>
          <a-radio :value="2">开奖时间段</a-radio>
        </a-radio-group>
        <div class="s_flex_ali" v-if="form.scan_award_confine_mode==1">
          <p>每月最多</p>
          <a-input-number class="m-l-10 m-r-10" v-model:value="form.scan_award_confine_month_max" :min='1' :max="5" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
          <p>次，每天最多提交</p>
          <a-input-number class="m-l-10 m-r-10" v-model:value="form.scan_award_confine_day_max" :min='1' :max="form.scan_award_confine_month_max" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
          <p>次</p>
        </div>
        <div class="s_flex_ali" v-if="form.scan_award_confine_mode==2">
          <p>每月</p>
          <a-input-number class="m-l-10 m-r-10" v-model:value="form.scan_award_confine_day_start" :min='1' :max="25" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
          <p>-</p>
          <a-input-number class="m-l-10 m-r-10" v-model:value="form.scan_award_confine_day_end" :min='form.scan_award_confine_day_start' :max="25" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
          <p>号，每天最多提交</p>
          <a-input-number class="m-l-10 m-r-10" v-model:value="form.scan_award_confine_day_max" :min='1' :max="5" :precision="0" placeholder="请输入" style="width:150px"></a-input-number>
          <p>次</p>
        </div>
      </div>
    </a-form-item>
  </a-form>
  <a-modal :keyboard="false" title="选择红包" v-model:visible="showRed" centered :width="1200" :footer="null"
    destroyOnClose>
    <selectBouns v-on:select="redSelect" :checkout="false"></selectBouns>
  </a-modal>
  <a-modal :keyboard="false" title="选择红包" v-model:visible="showRed1" centered :width="1200" :footer="null"
    destroyOnClose>
    <selectBouns v-on:select="redSelect1" :checkout="false"></selectBouns>
  </a-modal>
  <a-modal :keyboard="false" title="选择红包" v-model:visible="showRed2" centered :width="1200" :footer="null"
    destroyOnClose>
    <selectBouns v-on:select="redSelect2" :checkout="false"></selectBouns>
  </a-modal>
  <a-modal :keyboard="false" title="活动奖项" centered v-model:visible="showjx" :confirm-loading="confirmLoading"
    @ok="banConfirm" :width="800" destroyOnClose> <!--按角色发奖非默认-->
    <a-form ref="ruleForm" :rules="rules" :model="form1" :labelCol="{ span: 4 }">
      <a-form-item label="奖项名称" name="name" required>
        <a-input v-model:value="form1.name" placeholder="如：一等奖" style="width:300px"></a-input>
        <p class="s_c999">仅做后台查看使用，不在前端扫码展示</p>
      </a-form-item>
      <a-form-item label="发放对象" name="" required>
         <a-row :gutter="16" v-if="form1.is_default==1">
          <a-col :span="4">
            <a-checkbox v-model:checked="form1.is_boss" @change="(e) => changedl(e)">店老板
            </a-checkbox>
          </a-col>
         </a-row>
        <a-row :gutter="16">
          <a-col :span="3">
            <a-checkbox v-model:checked="form1.is_director" @change="(e) => changedz(e)">店长
            </a-checkbox>
          </a-col>
          <a-col :span="6" v-if="form1.is_default!=1">
            <a-select v-model:value="form1.director_level_id" :style="{ width: '240px' }" placeholder="请选择" :disabled="!form1.is_director">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in levelList" :key="item.id" :value="item.id">{{ item.level_name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="3">
            <a-checkbox v-model:checked="form1.is_clerk" @change="(e) => changdy(e)">店员</a-checkbox>
          </a-col>
          <a-col :span="6" v-if="form1.is_default!=1">
            <a-select v-model:value="form1.clerk_level_id" :style="{ width: '240px' }" placeholder="请选择" :disabled="!form1.is_clerk">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in leverList" :key="item.id" :value="item.id">{{ item.level_name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="5">
            <a-checkbox v-model:checked="form1.is_dealer_salesman">经销商业务员</a-checkbox>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="奖项内容" require name="" style="margin-bottom: 0" required>
        <div>
          <a-row :gutter="16">
            <a-col :span="3">
              <a-checkbox v-model:checked="form1.is_bonus" @change="handelchange1">红包 </a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-input v-model:value="form1.bonus_name" readonly placeholder="请选择红包" />
            </a-col>
            <a-col :span="4">
              <a-button type="primary" @click="showRed = true" :disabled="!form1.is_bonus"> 选择 </a-button>
            </a-col>
          </a-row>
          <p class="s_c999">为避免红包零钱发放失败,请确保红包零钱余额充足</p>
          <a-row :gutter="16">
            <a-col :span="3">
              <a-checkbox v-model:checked="form1.is_point">积分 </a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-input v-model:value="form1.point_num" placeholder="请输入积分数" :disabled="!form1.is_point" />
            </a-col>
          </a-row>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  <a-modal :keyboard="false" title="活动奖项" centered v-model:visible="showjxm" :confirm-loading="confirmLoading"
    @ok="banConfirm1" :width="800" destroyOnClose> <!--按角色发奖默认-->
    <a-form ref="ruleForm" :rules="rules" :model="form2" :labelCol="{ span: 4 }">
      <a-form-item label="奖项名称" name="name" required>
        <a-input v-model:value="form2.name" placeholder="如：一等奖" style="width:300px"></a-input>
        <p class="s_c999">仅做后台查看使用，不在前端扫码展示</p>
      </a-form-item>
      <a-form-item label="奖项内容" require name="" style="margin-bottom: 0" required>
        <div>
          <a-row :gutter="16">
            <a-col :span="3">
              <a-checkbox v-model:checked="form2.is_bonus" @change="handelchange2">红包 </a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-input v-model:value="form2.bonus_name" readonly placeholder="请选择红包" />
            </a-col>
            <a-col :span="4">
              <a-button type="primary" @click="showRed1 = true" :disabled="!form2.is_bonus">
                选择
              </a-button>
            </a-col>
          </a-row>
          <p class="s_c999">为避免红包零钱发放失败,请确保红包零钱余额充足</p>
          <a-row :gutter="16">
            <a-col :span="3">
              <a-checkbox v-model:checked="form2.is_point">积分 </a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-input v-model:value="form2.point_num" placeholder="请输入积分数" :disabled="!form2.is_point" />
            </a-col>
          </a-row>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  <!--按概率发奖-->
  <a-modal :keyboard="false" title="活动奖项" centered v-model:visible="showProbability" :width="800" destroyOnClose :footer="null"> 
    <probability :activity_id="activity_id" :award_id="odd_award_id" @oddsubmit="oddsubmit" @oddcolse="showProbability=false" :type="oddType" :quantity_type="quantity_type" :odd_list_length="oddList.length"></probability>
  </a-modal>
  <div class="s_flex_center">
    <a-button @click="provide()" class="m-t-20 m-r-20">上一步</a-button>
    <a-button type="primary" @click="next()" class="m-t-20">保存</a-button>
  </div>
</template>
<script>
  import {
    PlusOutlined,
    QuestionCircleOutlined,
    InfoCircleOutlined,
  } from "@ant-design/icons-vue";
  import { inject, ref, reactive, toRefs, onMounted } from "vue";
  import { message } from "ant-design-vue";
  import { getLevelList } from "@/api/clerk";
  import {
    prizeCreate,
    activitysOneDetail,
    prizeUpdate,
    prizeDelete,
    updateSys,
    updateBossNew,
    getGuideOddsList,
    guideOddsDel,guideActivityAwardCount
  } from "@/api/guide";
  import { iscode } from "@/utils/app";
  import probability from "./components/probability.vue"
  const def = {
    name: "",
    is_director: 0,
    director_level_id: 0,
    is_clerk: 0,
    clerk_level_id: 0,
    is_bonus: 0,
    bonus_id: "",
    point_num: "",
    is_point: 0,
    is_boss:0,
  };
  export default {
    components: {
      PlusOutlined,
      QuestionCircleOutlined,
      InfoCircleOutlined,
      probability
    },
    props: {
      activity_id: {
        type: Number,
        default: () => {
          return null;
        },
      },
      actionType:{
        type:String
      }
    },
    name: "setpsThree",
    setup(props, { emit }) {
      const form1 = ref({ ...def });
      const form2 = ref({ ...def });
      const bonus = ref({});
      const form = ref({
        is_boss: 0,
        boss_type: 1,
        // many_awards_type: 0,
        boss_is_bonus: 0,
        boss_bonus_id: "",
        boss_is_point: 0,
        boss_point_num: "",
      });
      const showRed = ref(false);
      const showRed1 = ref(false);
      const showRed2 = ref(false);
      const list = ref([]);
      const levelList = ref([]);
      const leverList = ref([]);
      const state = reactive({
        oddCount:{},
        odd_award_id:0,//概率奖id
        allPercent:0,//概率奖综合中奖率
        oddType:'add',//概率奖添加/编辑type
        oddList:[],//概率奖列表
        showProbability:false,
        award_method:1,
        showjx: false,
        showjxm: false,
        confirmLoading: false,
        isEdit: 0,
        isAdd: 0,
        rules: {
          name: [{ required: true, message: "请输入奖项名称" }],
        },
        quantity_type:2
      });

      let columns = [
        {
          title: "奖项名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "奖项内容",
          dataIndex: "bonus_id",
          key: "bonus_id",
        },
        {
          title: "指定对象发奖",
          dataIndex: "level_name",
          key: "level_name",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          slots: { customRender: "action" },
        },
      ];
      let columns1 = [
        {
          title: "奖项名称",
          dataIndex: "award_name",
          key: "award_name",
        },
        {
          title: "中奖码数量",
          dataIndex: "award_num",
          key: "award_num",
        },
        {
          title: "中奖概率",
          dataIndex: "percent",
          key: "percent",
          customRender: function ({ record }) {
            return record.percent + "%"
          },
        },
        {
          title: "奖项内容",
          dataIndex: "award_content_arr",
          key: "award_content_arr",
          slots: { customRender: "award_content_arr" },
        },
        {
          title: "已中奖数量",
          dataIndex: "award_sure_num",
          key: "award_sure_num",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          slots: { customRender: "action" },
        },
      ];
      const redSelect = (data) => {
        form1.value.bonus_id = data.id;
        form1.value.bonus_name = data.amount+'元'+data.bonus_type_text;
        showRed.value = false;
      };
      const redSelect1 = (data) => {
        form2.value.bonus_id = data.id;
        form2.value.bonus_name = data.amount+'元'+data.bonus_type_text;
        showRed1.value = false;
      };
      const redSelect2 = (data) => {
        bonus.value = {
          boss_bonus_id: data.id,
          bonus_name: data.amount+'元'+data.bonus_type_text,
        };
        showRed2.value = false;
      };
      // 获取详情
      const detail = async () => {
        let result = await activitysOneDetail(props.activity_id)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result)) {
          form.value = {
            is_boss: result.data.is_boss,
            boss_type: result.data.boss_type,
            boss_is_bonus: result.data.boss_is_bonus,
            boss_bonus_id: result.data.boss_bonus_info.bonus_id,
            boss_is_point: result.data.boss_is_point,
            boss_point_num: result.data.boss_point_info.point_num,
            send_award_type: result.data.send_award_type,
            award_is_permit:result.data.award_is_permit,
            send_award_mode:result.data.send_award_mode,
            send_award_mode_day:result.data.send_award_mode_day,
            scan_award_is_confine:result.data.scan_award_is_confine,
            scan_award_confine_mode:result.data.scan_award_confine_mode,
            scan_award_confine_day_max:result.data.scan_award_confine_day_max,
            scan_award_confine_month_max:result.data.scan_award_confine_month_max,
            scan_award_confine_day_start:result.data.scan_award_confine_day_start,
            scan_award_confine_day_end:result.data.scan_award_confine_day_end,
            scan_award_is_collection:result.data.scan_award_is_collection,
            scan_award_collection_is_sale_bill:result.data.scan_award_collection_is_sale_bill,
            scan_award_collection_is_gps_position:result.data.scan_award_collection_is_gps_position,
            scan_award_collection_is_product_img:result.data.scan_award_collection_is_product_img
          };
          bonus.value.boss_bonus_id = form.value.boss_bonus_id;
          bonus.value.boss_bonus_name =  result.data.boss_bonus_info.bonus_name;
          if(result.data.send_award_type==2){
            getOddsList();
            getListItemCount();
            return
          }
          list.value = result.data.prize_data;
          list.value.forEach((item) => {
            if (item.bonus_info == "" && item.point_info == "") {
              item.bonus_id = "";
            } else if (item.bonus_info != "" && item.point_info == "") {
              item.bonus_id = item.bonus_info.bonus_name;
            } else if (item.bonus_info != "" && item.point_info != "") {
              item.bonus_id =
                item.bonus_info.bonus_name + item.point_info.point_num + "积分";
            } else if (item.bonus_info == "" && item.point_info != "") {
              item.bonus_id = item.point_info.point_num + "积分";
            }
          });
        } else {
          message.error(result.message);
        }
      };
      const addOdd = () =>{
        if(Number(state.oddCount.percent)>=100){
          message.error('可分配的二维码数量为0');
          return
        }
        state.showProbability=true;
        state.oddType='add';
        state.odd_award_id='';
      }
      //概率发奖列表
      const getOddsList = async () => {
        state.allPercent = 0;
        let res = await getGuideOddsList(props.activity_id).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          state.oddList = res.data;
          if(state.oddList.length){
            state.quantity_type = state.oddList[0].quantity_type;
            state.oddList.forEach(v=>{
              state.allPercent+=Number(v.percent);
            })
          }
        } else {
          message.error(res.msg);
        }
      }
      //概率发奖-统计
      const getListItemCount = async () => {
        let res = await guideActivityAwardCount(props.activity_id).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          state.oddCount = res.data;
        } else {
          message.error(res.msg);
        }
      }
      //概率发奖删除
      const oddsDel = async (e) => {
        let res = await guideOddsDel({activity_id:props.activity_id,award_id:e.award_id}).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          getOddsList();
          getListItemCount();
          message.success(res.message);
        } else {
          message.error(res.message);
        }
      }
      //添加概率奖
      const oddsubmit = () =>{
        getOddsList();
        getListItemCount();
        state.showProbability = false;
      }
      //指定发奖删除
      const del = async (e) => {
        let res = await prizeDelete(e.prize_id).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          detail();
          message.success(res.debug.message);
        } else {
          message.error(res.debug.message);
        }
      };
      const handelchange = (e) => {
        if (e.target.checked == false) {
          bonus.value.boss_bonus_id = "";
          bonus.value.boss_bonus_name = "";
        }
      };
      //指定发奖编辑
      const edit = async (e) => {
        if (e.id == 0) {
          state.isEdit = 2;
          state.showjxm = true;
          form2.value = {
            is_bonus: e.is_bonus,
            bonus_info: e.bonus_info,
            is_point: e.is_point,
            name: e.name,
            bonus_id: e.bonus_info.bonus_id,
            bonus_name: e.bonus_info.bonus_name,
            point_num: e.point_info.point_num,
              is_boss: e.is_boss,
          };
        } else {
          state.isEdit = 0;
          state.showjx = true;
          form1.value = {
            name: e.name,
            is_director: e.is_director,
             is_boss: e.is_boss,
            director_level_id: e.director_level_id,
            is_clerk: e.is_clerk,
            clerk_level_id: e.clerk_level_id,
            is_bonus: e.is_bonus,
            bonus_id: e.bonus_info.bonus_id,
            point_num: e.point_info.point_num,
            bonus_name: e.bonus_info.bonus_name,
            is_point: e.is_point,
            prize_id: e.prize_id,
            is_default:e.is_default,
            is_dealer_salesman: e.is_dealer_salesman,
          };
          if (form1.value.is_director == 0) {
            form1.value.director_level_id = 0
          }
          if (form1.value.is_clerk == 0) {
            form1.value.clerk_level_id = 0
          }
        }
      };
      const changedz = (e) => {
        e.target.checked == true
          ? (form1.value.director_level_id = 0)
          : (form1.value.director_level_id = null);
      };
      const changdy = (e) => {
        e.target.checked == true
          ? (form1.value.clerk_level_id = 0)
          : (form1.value.clerk_level_id = null);
      };

      const banConfirm1 = async () => {
        state.confirmLoading = true;
        form2.value = {
          award_is_bonus: form2.value.is_bonus,
          award_bonus_id: form2.value.bonus_id,
          award_is_point: form2.value.is_point,
          award_point_num: form2.value.point_num,
          award_name: form2.value.name,
        };
        form2.value.award_is_bonus == true
          ? (form2.value.award_is_bonus = 1)
          : (form2.value.award_is_bonus = 0);
        form2.value.award_is_point == true
          ? (form2.value.award_is_point = 1)
          : (form2.value.award_is_point = 0);
        let res = await updateSys(props.activity_id, form2.value).then(
          (res) => res.data
        ).catch((error) => error);
        
        state.confirmLoading = false;
        if (iscode(res)) {
          state.showjxm = false;
          detail();
          message.success(res.message);
        } else {
          message.error(res.message);
          state.showjxm = false;
        }
      };
      //新增指定发奖
      const banConfirm = async () => {
        state.confirmLoading = true;
        form1.value.is_bonus = form1.value.is_bonus?1:0;
        form1.value.is_point = form1.value.is_point?1:0;
        form1.value.is_director = form1.value.is_director?1:0;
        form1.value.is_clerk = form1.value.is_clerk?1:0;
        form1.value.is_dealer_salesman = form1.value.is_dealer_salesman?1:0;
        form1.value.is_boss = form1.value.is_boss?1:0;
        let res;
        if(state.isEdit == 1){
          res = await prizeCreate(props.activity_id, {...form1.value}).then( (res) => res.data ).catch((error) => error)
        }else{
          res = await prizeUpdate(props.activity_id, {...form1.value}).then( (res) => res.data ).catch((error) => error)
        }
        state.confirmLoading = false;
        if (iscode(res)) {
          state.showjx = false;
          form1.value = {};
          detail();
          message.success(res.message);
        } else {
          message.error(res.message);
        }
      };
      //获取店长类型
      const getLevel = async (e) => {
        let res = await getLevelList({ type_id: 2 }).then((res) => res.data);
        if (iscode(res)) {
          levelList.value = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      //获取店长类型
      const getLever = async (e) => {
        let res = await getLevelList({ type_id: 3 }).then((res) => res.data);
        if (iscode(res)) {
          leverList.value = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      const create = () => {
        state.isEdit = 1;
        state.showjx = true;
        if (state.isEdit == 1) {
          form1.value = {
            name: "",
            is_director: 0,
            director_level_id: 0,
            is_clerk: 0,
            clerk_level_id: 0,
            is_bonus: 0,
            bonus_id: "",
            point_num: "",
            is_point: 0,
            is_dealer_salesman:0
          };
        }
      };
      // 下一步
      const $router = inject("$router");
      const next = async () => {
        form.value = {
          ...form.value,
        };
        form.value.scan_award_collection_is_sale_bill = form.value.scan_award_collection_is_sale_bill?1:0;
        form.value.scan_award_collection_is_gps_position = form.value.scan_award_collection_is_gps_position?1:0;
        form.value.scan_award_collection_is_product_img= form.value.scan_award_collection_is_product_img?1:0;
        form.value.boss_bonus_id = bonus.value.boss_bonus_id;
        form.value.boss_is_bonus == true
          ? (form.value.boss_is_bonus = 1)
          : (form.value.boss_is_bonus = 0);
        form.value.boss_is_point == true
          ? (form.value.boss_is_point = 1)
          : (form.value.boss_is_point = 0);
        let res = await updateBossNew(props.activity_id, form.value).then(
          (res) => res.data
        );
        if (iscode(res)) {
          message.success(res.message);
          $router.go(-1);
        } else {
          message.error(res.message);
        }
      };
      const provide = () => {
        emit("setpsThreeProvide", 1);
      };
      onMounted(() => {
        getLevel();
        getLever();
        detail();
      });
      return {
        ...toRefs(state),
        columns,
        columns1,
        next,
        provide,
        form,
        bonus,
        showRed,
        showRed1,
        showRed2,
        redSelect,
        redSelect1,
        redSelect2,
        create,
        form1,
        changedz,
        banConfirm,
        changdy,
        list,
        levelList,
        leverList,
        edit,
        form2,
        banConfirm1,
        del,
        handelchange,
        oddsDel,
        oddsubmit,
        addOdd
        // handleadd
      };
    },
  };
</script>